import React from 'react';
import axios from 'helpers/axios';

import {
  Container,
  Title,
  TextInput,
  Button,
  Form,
  Image,
  Label,
  TextLink,
} from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useToasts, useUser, useLayout } from 'hooks';
import { CloseButton } from 'ui/components/shared';

export const TFALogin = () => {
  const [token, setToken] = React.useState('');
  const { setLayoutLoading } = useLayout();
  const { errorToast } = useToasts();
  const { challenges, saveChallenges, signOut, redirectToDashboard } = useUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.post('/challenges/otp/verify', { token });
      if (response.status === 200) {
        if (response.data?.success) {
          saveChallenges({ valid: true });
          redirectToDashboard();
          return;
        } else {
          errorToast('Token code is wrong!');
        }
      }
    } catch (error) {
      errorToast({ error, default: 'Error: 2FA login.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout show={challenges.required} justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Two-step verification</Title>
        <Title type="h3" variant="grey" mb="m">
          Thanks for keeping your account secure.
          <br />
          Check your token device.
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container>
            <Label htmlFor="token" mb="xs">
              Your token code
            </Label>
            <TextInput
              id="token"
              name="token"
              type="token"
              length={6}
              placeholder="6-digit code"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            Log in Securely
          </Button>
          <TextLink my="m" to="/2fa/sms">
            No I want to use my phone number
          </TextLink>
        </Form>
      </Container>
      <CloseButton title="Logout" onClick={signOut} />
    </AuthLayout>
  );
};
